import { Action, BulkActionsBar } from 'ui/bulkActionsBar';
import { FullWidth } from 'ui/utility/fullWidth';
import { FolderMove16 } from 'ui/icons/aurora/16px/FolderMove16';

import { CreativeLibraryControls } from './CreativeLibraryControls';
import { CreativeLibraryHeader } from './CreativeLibraryHeader';
import { CreativeLibraryPaginationFooter } from './CreativeLibraryPaginationFooter';
import { Table } from './tableView/Table';
import { Cards } from './cardView/Cards';
import { Takeover } from './takeover/Takeover';
import { useViewContext, CREATIVE_LIBRARY_VIEWS } from '../../contexts/ViewContext';
import { useSelectionContext } from '../../contexts/SelectionContext';
import { useTakeoverContext } from '../../contexts/Takeover';
import { useAssetsQueryContext } from '../../contexts/AssetsQueryContext';
import { useTranslations } from '../../hooks/useTranslations';
import { CreativeLibraryModals } from '../modals/CreativeLibraryModals';
import { useCreativeLibraryFolderModals } from 'modules/creativeLibrary/hooks/useCreativeLibraryModals';
import { FolderBreadcrumbs } from 'ui/indexPages/folders/folderBreadcrumbs';
import { Delete16 } from 'ui/icons/aurora/16px/Delete16';

export const testIds = {
  indexPage: 'cl-index-page',
};

export const IndexPage = () => {
  const { t } = useTranslations();
  const { activeView, hasManageBaseTemplatesPermission } = useViewContext();
  const { isOpen: isUploadTakeoverOpen } = useTakeoverContext();
  const { bulk, selectBulk } = useSelectionContext();
  const { assetCountTotal, currentFolder, rootFolderId } = useAssetsQueryContext();
  const modals = useCreativeLibraryFolderModals();
  const showActionBar = hasManageBaseTemplatesPermission && bulk.length > 0;

  const BULK_ACTIONS: Action[] = [
    {
      icon: <FolderMove16 />,
      label: t('button.moveToFolder'),
      onClick: () => {
        selectBulk();
        modals.move.toggle(true);
      },
      sortIndex: 1,
    },
    {
      icon: <Delete16 />,
      label: t('button.delete'),
      onClick: () => {
        selectBulk();
        modals.delete.toggle(true);
      },
      sortIndex: 2,
    },
  ];

  const isTableView = activeView === CREATIVE_LIBRARY_VIEWS.TABLE;
  return (
    <div data-test={testIds.indexPage}>
      <CreativeLibraryHeader />
      {showActionBar ? (
        <FullWidth>
          <BulkActionsBar actions={BULK_ACTIONS} numSelected={bulk.length} />
        </FullWidth>
      ) : (
        <CreativeLibraryControls />
      )}
      {!!currentFolder?.ancestors.length && currentFolder.id && (
        <FullWidth>
          <FolderBreadcrumbs
            folderAncestors={[
              ...currentFolder.ancestors,
              { id: currentFolder.id, name: currentFolder?.name },
            ]}
            rootFolderId={rootFolderId}
          />
        </FullWidth>
      )}

      {isTableView ? <Table /> : <Cards />}
      <FullWidth>
        <CreativeLibraryPaginationFooter assetsCount={assetCountTotal} />
      </FullWidth>

      {hasManageBaseTemplatesPermission && isUploadTakeoverOpen && <Takeover />}
      <CreativeLibraryModals />
    </div>
  );
};
